import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { ExpandableListItemSkeleton as ExpandableListItemSkeletonCompass } from "./ExpandableListItemSkeletonCompass";
import { ExpandableListItemSkeleton as ExpandableListItemSkeletonUiKit } from "./ExpandableListItemSkeletonUiKit";

export const ExpandableListItemSkeleton = () => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return <ExpandableListItemSkeletonCompass />;
  }

  return <ExpandableListItemSkeletonUiKit />;
};
